/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { bannersApi } from '../lib/api';

const resolveHref = (banner) => {
  const t = banner.link_type;
  const v = (banner.link_value || '').trim();
  if (!v && t !== 'none') return null;
  switch (t) {
    case 'product': return { internal: true, href: `/product/${v}` };
    case 'collection': return { internal: true, href: `/shop?category=${encodeURIComponent(v)}` };
    case 'cms': return { internal: true, href: v.startsWith('/') ? v : `/${v}` };
    case 'url': return { internal: !/^https?:\/\//i.test(v), href: v };
    default: return null;
  }
};

const PromoBanner = () => {
  const [banner, setBanner] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    bannersApi.list('promo')
      .then((list) => setBanner(list && list.length > 0 ? list[0] : null))
      .catch(() => setBanner(null))
      .finally(() => setLoaded(true));
  }, []);

  if (!loaded || !banner) return null;

  const link = resolveHref(banner);

  const handleClick = () => {
    if (!link) return;
    if (link.internal) {
      navigate(link.href);
    } else if (banner.open_in_new_tab) {
      window.open(link.href, '_blank', 'noopener,noreferrer');
    } else {
      window.location.href = link.href;
    }
  };

  const content = (
    <picture>
      {banner.image_mobile && (
        <source media="(max-width: 640px)" srcSet={banner.image_mobile} />
      )}
      {banner.image_tablet && (
        <source media="(max-width: 1024px)" srcSet={banner.image_tablet} />
      )}
      <img
        src={banner.image_desktop}
        alt={banner.title || 'Promotional banner'}
        loading="lazy"
        decoding="async"
        className="w-full h-auto block select-none"
        draggable={false}
      />
    </picture>
  );

  return (
    <section className="w-full bg-[#ece4d2]">
      {link ? (
        <button
          type="button"
          onClick={handleClick}
          className="block w-full cursor-pointer"
          aria-label={banner.title || 'Open promotional banner link'}
        >
          {content}
        </button>
      ) : (
        <div className="w-full">{content}</div>
      )}
    </section>
  );
};

export default PromoBanner;
